import { create } from 'zustand';

interface UiState {
  desktopCollapsed: boolean;
  setDesktopCollapsed: (desktopCollapsed: boolean) => void;
  toggleDesktopCollapsed: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  desktopCollapsed: false,
  setDesktopCollapsed: (desktopCollapsed) => set({ desktopCollapsed }),
  toggleDesktopCollapsed: () => set((state) => ({ desktopCollapsed: !state.desktopCollapsed })),
}));
